import { ProductData } from '../../../hooks/useContentMgmt';

export type ChargerDisplayInfo = {
  productId?: string | null;
  suppliedByCustomer?: boolean | null;
  validatedProductName?: string | null;
};

export const resolveChargerDisplayName = (
  charger: ChargerDisplayInfo,
  evChargerProductList: ProductData[],
): string => {
  const matchedProductEntryName = charger.productId
    ? evChargerProductList.find(product => product.id === charger.productId)
        ?.entryName
    : undefined;

  return (
    (charger.suppliedByCustomer && charger.validatedProductName) ||
    matchedProductEntryName ||
    'NA'
  );
};
